let translations = window.appData && window.appData.translations ? window.appData.translations : {}

export default {
  translate(key) {
    if (translations[key]) {
      return translations[key]
    }
    return 'Missing translation ' + key
  }
}